import React, { Component } from 'react'
import { Field } from 'redux-form'
import { renderSelectField } from '../../Forms/fieldRenderers'
import { Row, Col } from 'react-bootstrap'
import { renderTextField } from '../../Forms/fieldRenderers'

import {
  required
} from '../../Forms/fieldValidators'

const maxLength = max => value =>
  value && value.length > max ? `Debe tener un máximo de ${max} caracteres de largo` : undefined
const number = value => value && isNaN(Number(value)) ? 'Debe ingresar un valor Numérico' : undefined
const maxLength16 = maxLength(16)

class CamposCoem extends Component {
  render () {
    const {
      selectedExportador,
      isRequesting,
      onSelect,
      renderExportadores
     } = this.props

    return (
      <div>
        <Row>
          {/* <Col md={2}>
            <Field
              name='item'
              type='text'
              label='Item'
              component={renderTextField}
              autoFocus
              validate={[required, number]}
              placeholder='1'
            />
          </Col> */}
          <Col md={7}>
            <Field
              name='identificadorDeclaracion'
              type='text'
              label='Destinación/Permiso de Embarque'
              component={renderTextField}
              autoFocus={false}
              validate={[required, maxLength16]}
              placeholder='23067EC01000074X'
            />
          </Col>
          <Col md={3}>
            <Field
              name='peso'
              type='text'
              label='Total bultos'
              component={renderTextField}
              autoFocus={false}
              validate={[required, number]}
              placeholder=''
            />
          </Col>
          <Col md={2}/>
        </Row>
        <Row>
          <Col md={12}>
            <Field
              onChange={onSelect}
              name='exportador'
              label='Exportador'
              autoFocus={false}
              component={renderSelectField}
              value={selectedExportador}
            >
              {isRequesting ? null : renderExportadores()}
            </Field>
          </Col>
        </Row>
      </div>
    )
  }
}

export default CamposCoem
